import React from "react";
import {FontAwesome} from "@expo/vector-icons";
import MainButton from "./MainButton";
import {useNavigation, useTheme} from "@react-navigation/native";

export default function SelectButton(props) {
    const navigation = useNavigation();
    const theme = useTheme();

    return (<MainButton
        title={<FontAwesome style={{fontSize:24, color:theme.colors.scheme[2]}} name={'gear'} />}
        onPress={() => navigation.navigate('Settings')} />)
}